@if (allowedTestUsers$ | async; as allowedTestUsers) {
<div>
  @if ( (activeUserId$ | async); as activeUser ) {
  <div>
    @if (!allowedTestUsers.length) {
    <button class="mobi-ui-btn-silent" data-test-id="activeUser">
      <mobi-ui-icon-major name="user_group" class="icon" />
      {{ activeUser }}
    </button>
    } @else {
    <button
      #popOver="mobiUiPopover"
      [mobiUiPopover]="componentContentPopoverUsers"
      class="mobi-ui-btn-silent"
      data-test-id="activeUser"
    >
      <mobi-ui-icon-major name="user_group" class="icon" />
      {{ activeUser }}
    </button>
    <ng-template #componentContentPopoverUsers let-popover>
      <mobi-ui-popover-major [popover]="popover">
        <mobi-ui-radio-button-group-major
          [value]="activeUser"
          (valueChange)="handleValueChange($any($event), popOver)"
        >
          @for ( testuser of allowedTestUsers; track testuser.userId ) {
          <mobi-ui-radio-button-major [value]="testuser.userId" icon="user">
            {{ testuser.anzeigeName + ' (' + testuser.userId + ')' }}
          </mobi-ui-radio-button-major>
          }
        </mobi-ui-radio-button-group-major>
      </mobi-ui-popover-major>
    </ng-template>
    }
  </div>
  }
</div>
}
